import { createEventListener } from "@solid-primitives/event-listener";
import { Ref } from "@solid-primitives/refs";

interface ClosableProps {
  can: boolean;
  do (): void;
}
const Context = createContext<ClosableProps>({
  can: false,
  do: () => {}
});

export function ClosableProvider (props: ParentProps<{can: boolean, do: () => void}>) {
  return (
    <Context.Provider value={props}>
      {props.children}
    </Context.Provider>
  )
}

/** 使该组件行为，可以触发关闭行为  
 * 大致包括了以下行为  
 * 1.清空输入框
 * 2.关闭对话框
 * 3.关闭弹出层
 * 4.关闭toast
 * @returns 
 */
export function Closable (props: ParentProps<{auto?: boolean}>) {
  const ctx = useContext(Context);
  function build () {
    return (
      <Ref ref={el => createEventListener(el, 'click', () => ctx.do())}>
        {props.children}
      </Ref>
    )
  }
  if (props.auto !== true) {
    return build();
  }
  return (
    <Toggle when={ctx.can}>{build()}</Toggle>
  )
}

